module.exports = __webpack_public_path__ + "static/media/dark-theme-total-exit.a1b5a6fe.svg";